export const PRODUCT_REQUEST = "PRODUCT_REQUEST";
export const PRODUCT_SUCCESS = "PRODUCT_SUCCESS";
export const PRODUCT_FAIL = "PRODUCT_FAIL";

export const TOP_PRODUCT_REQUEST = "TOP_PRODUCT_REQUEST";
export const TOP_PRODUCT_SUCCESS = "TOP_PRODUCT_SUCCESS";
export const TOP_PRODUCT_FAIL = "TOP_PRODUCT_FAIL";

export const PRODUCT_SINGLE_REQUEST = "PRODUCT_SINGLE_REQUEST";
export const PRODUCT_SINGLE_SUCCESS = "PRODUCT_SINGLE_SUCCESS";
export const PRODUCT_SINGLE_FAIL = "PRODUCT_SINGLE_FAIL";
export const PRODUCT_SINGLE_RESET = "PRODUCT_SINGLE_RESET";

export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAIL = "ADD_PRODUCT_FAIL";

export const EDIT_PRODUCT_REQUEST = "EDIT_PRODUCT_REQUEST";
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAIL = "EDIT_PRODUCT_FAIL";

export const ADD_PRODUCT_REVIEW_REQUEST = "ADD_PRODUCT_REVIEW_REQUEST";
export const ADD_PRODUCT_REVIEW_SUCCESS = "ADD_PRODUCT_REVIEW_SUCCESS";
export const ADD_PRODUCT_REVIEW_FAIL = "ADD_PRODUCT_REVIEW_FAIL";
export const ADD_PRODUCT_REVIEW_RESET = "ADD_PRODUCT_REVIEW_RESET";
